import React from 'react';
import './Footer.css';
import { Link } from 'react-router-dom';
import Logo from '../Assets/LOGO.webp';

/* const logo = "https://caninecrown.ascentbw.com/Image/Logo.webp";
 */
const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        
        {/* Column 1: Logo */}
        <div className="footer-branding">
          <img src={Logo} alt="Canine Crown Logo" className="footer-logo" />
        </div>

        {/* Column 2: Company */}
        <div className="footer-col">
          <h3>Company</h3>
          <ul>
            <li><Link to="/">Home</Link></li>
            <li><Link to="/about">About Us</Link></li>
            <li><Link to="/dog-products">Dogs</Link></li>
            <li><Link to="/cat-products">Cats</Link></li>
            <li><Link to="/contact">Contact</Link></li>
          </ul>
        </div>

        {/* Column 3: Product Categories */}
        <div className="footer-col">
          <h3>PRODUCT CATEGORIES</h3>
          <ul>
            <li><Link to="/dog-products">Dog Nutrition</Link></li>
            <li><Link to="/cat-products">Cat Nutrition</Link></li>
            <li><Link to="/category/dog/Treats">Treats & Biscuits</Link></li>
            <li className="explore-wrapper">
              <Link to="/products" className="explore-link">
                Explore All Products <span className="arrow-icon">→</span>
              </Link>
            </li>
          </ul>
        </div>

        {/* Column 4: Contact */}
        <div className="footer-col contact-col">
          <h3>CONTACT US</h3>
          <div className="contact-item">
            <div className="icon-circle">
              <svg width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z"></path><circle cx="12" cy="10" r="3"></circle></svg>
            </div>
            <p>
              Canine Crown India Pvt Ltd<br />
              Ground Floor &amp; 1st Floor, No. 135/2,<br />
              Balamurugan Kovil Street, Sunaresan Nagar,<br />
              Anna Industrial Estate, Vanagaram,<br />
              Chennai, Tamil Nadu 600095.
            </p>
          </div>
          <div className="contact-item">
            <div className="icon-circle">
              <svg width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path><polyline points="22,6 12,13 2,6"></polyline></svg>
            </div>
            <p>info@caninecrown.in</p>
          </div>
          <div className="contact-item">
            <div className="icon-circle">
              <svg width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07 19.5 19.5 0 01-6-6 19.79 19.79 0 01-3.07-8.67A2 2 0 014.11 2h3a2 2 0 012 1.72 12.84 12.84 0 00.7 2.81 2 2 0 01-.45 2.11L8.09 9.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45 12.84 12.84 0 002.81.7A2 2 0 0122 16.92z"></path></svg>
            </div>
            <p>+91 74488 80880</p>
          </div>
          
        </div>

      </div>

      {/* Bottom Bar */}
      <div className="footer-bottom-bar">
        <div className="footer-bottom-container">
          <div className="fb-left">© 2026 Canine Crown. All rights reserved.</div>
          <div className="fb-center">Terms and conditions | Privacy Policy</div>
          <div className="fb-right">Designed by Ascent Brandworks</div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
